<template>
  <div>
    <div v-if="userHasPermission(constants.PERMISSION_TYPES.USER, constants.PERMISSION_VALUES.CREATE)" class="spl-create-user">
      <subpage-header back-link="dashboard" label="Create User by File" />

      <div class="spl-create-user-row">
        <div class="spl-dashboard">
          <input
            id="usersFile"
            ref="usersFile"
            type="file"
            size="50">
          <form-button @onClick="uploadUserFile">
            Create Users
          </form-button>
        </div>
      </div>

      <div class="spl-create-user-table">
        <div v-if="isLoading" class="spl-load-img" />
        <p v-if="!isLoading">
          Following users created
        </p>
        <table v-if="!isLoading">
          <thead>
            <tr class="spl-create-user-table__head">
              <th
                v-for="(column, index) in userColumns"
                :key="'bookWithFilePreviewHeader' + index"
                class="spl-create-user-table__field">
                {{ column.label }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(user, index) in createdUsers"
              :key="'bookWithFilePreviewParcel' + index">
              <td
                v-for="(column, columnIndex) in userColumns"
                :key="'bookWithFilePreviewColumn' + columnIndex"
                :class="{'spl-create-user-table__field--number': isNumber(user[column.name]),
                         'spl-create-user-table__field--empty': isEmpty(user[column.name]),
                         'spl-create-user-table__field--long': column.long,
                         'spl-create-user-table__field--bold': column.bold}">
                {{ formatField(user[column.name], column.name, column.type) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <message-modal />
    </div>
  </div>
</template>

<script>
import Helpers from '@/helpers'
import constants from '@/constants'
import webApi from '@/webApi'
import { mapGetters } from 'vuex'
import { isNumber, round, map, flatMap, filter } from 'lodash'

export default {
  name: 'CreateUserWithFile',
  mixins: [Helpers],
  data () {
    return {
      constants,
      userColumns: [
        { name: 'FullName', label: 'Name', selected: true },
        { name: 'Email', label: 'E-Mail', selected: true },
        { name: 'Roles_String', label: 'Roles', selected: true },
        { name: 'Countries', label: 'Countries', selected: true, long: true },
        { name: 'Customers', label: 'Customers', selected: true, long: true }
      ],
      createdUsers: [],
      isLoading: false
    }
  },
  computed: {
    ...mapGetters('country', ['countryNames']),
    ...mapGetters('customer', ['customerNames'])
  },
  methods: {
    uploadUserFile () {
      var fileToUpload = this.$refs.usersFile.files[0]
      var formData = new FormData()
      this.isLoading = true
      formData.append('file', fileToUpload)
      webApi.account.create_Users_With_Excel_File(formData).then((response) => {
        var modifiedUserData = map(response.data, (user) => {
          var countryIDs = map(flatMap(filter(user.Claims, { ClaimType: 'Country_Permission' }), 'ClaimValue'), Number)
          user.Countries = this.countryNames(countryIDs).join(', ')
          var customerIDs = map(flatMap(filter(user.Claims, { ClaimType: 'Customer_Permission' }), 'ClaimValue'), Number)
          user.Customers = this.customerNames(customerIDs).join(', ')
          user.Roles_String = map(user.Roles, 'RoleId').join(', ')
          return user
        })
        this.createdUsers = modifiedUserData
        this.isLoading = false
      }).catch((error) => {
        this.isLoading = false
        window.bus.$emit('openErrorModal', error.response.data)
      })
    },
    // Special formatting for fields
    formatField (field, name, type) {
      // Weight & Picked up weight will be rounded to two decimal places then fixed in order to improve readability
      if (name === constants.PARCEL_FIELD_KEYS.WEIGHT) {
        return round(field, 2).toFixed(2)
      } else if (name === constants.PARCEL_FIELD_KEYS.VOLUME) {
        // Volume will be rounded to 3 decimal places
        return round(field, 3).toFixed(3)
      } else if (type === 'Date') {
        return this.formatDate(field, false, 'YYYY-MM-DD')
      } else if (type === 'Time') {
        return this.formatDate(field, true, 'YYYY-MM-DD HH:mm')
      }
      // empty fields will be removed
      if (field == null || field === 0) {
        return ''
      }
      return field
    },
    // including of helper since lodash not available in vue template
    isNumber (value) {
      return isNumber(value)
    },
    // helper for removing 0 elements
    isEmpty (value) {
      return value === 0
    }
  }
}
</script>
<style lang="scss">
  @import '../variables.scss';
  .spl-create-user {
     background-color: $tableRowBackgroundColorSelected;
     height: calc(100vh);
  }
  .spl-create-user-row {
    margin: 10px 70px;
  }

  .spl-create-user-table {
    margin: 0 70px;
    overflow: auto;
    width: calc(100% - 138px);
    height: calc(100vh - 230px);

    table {
      border-spacing: 0;
      // table-layout: fixed;
    }
    &__head {
      th {
        box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 3px 5px 0 rgba(0, 0, 0, 0.1);
      }
      &--sticky {
        position: sticky;
        left: 41px;
        z-index: 3 !important;
      }
      &--checkbox {
        .spl-checkbox {
          margin: 10px 2px 0 6px;
        }
        position: sticky;
        left: 0px;
        z-index: 3 !important;
      }
    }
    &__row {
      &--valid td {
        background-color: $successGreenBackground;
      }
      &--warning td {
        background-color: $warningOrangeBackground;
      }
      &--error td {
        background-color: $errorRedBackground;
      }
    }
    &__tooltip {
      display: none;
      position: absolute;
      background-color: $tableHeaderBackgroundColor;
      border: 1px solid $tableRowBorderColor;
      bottom: 20px;
      left: 40px;
      overflow: visible;
      color: black;
      z-index: 5;
      padding: 5px;
    }
    &__field {
      &--number {
        text-align: right;
        width: 70px;
      }
      &--sticky {
        position: sticky;
        left: 0px;
        box-shadow: 3px 0px 3px 0px rgba(0, 0, 0, 0.2);
        background-color: $tableHeaderBackgroundColor;
      }
      &--checkbox {
        .spl-checkbox {
          margin: 0 2px 0 6px;
        }
        position: sticky;
        background-color: $tableHeaderBackgroundColor;
        left: 0;
      }
      &--long {
        max-width: 300px !important;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      &--success {
        border-bottom: 2px solid $green !important;
        padding-bottom: 3px !important;
        font-weight: 600;
        color: $green;
      }
      &--warning {
        border-bottom: 2px solid $darkYellow !important;
        padding-bottom: 3px !important;
        font-weight: 600;
        color: $darkYellow;
      }
      &--error {
        border-bottom: 2px solid $red !important;
        padding-bottom: 3px !important;
        font-weight: 600;
        color: $red;
      }
      &--bold {
        font-weight: 600;
      }
      &--empty:hover {
        background-color: $tableRowBackgroundColorHover !important;
      }
    }
    thead {
      th {
        position: sticky;
        top: 0;
        text-align: left;
        font-family: $mono;
        font-size: 9px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 1px;
        line-height: 12px;
        background-color: $tableHeaderBackgroundColor;
        padding: 0px 5px  0px 5px;
        height: 40px;
        z-index: 2;
        border-bottom: 1px solid $tableHeaderBorderColor;
      }

      th:hover {
        background-color: $tableColumnBackgroundColorHover;
        cursor: pointer;
      }
    }
    tbody {

      tr {
        background-color: $tableRowBackgroundColor;
      }

      tr:hover {
        background-color: $tableRowBackgroundColorHover;
      }

      td {
        border-style: solid;
        border-width: 0 1px 1px 0;
        border-color: $tableRowBorderLowColor;
        border-bottom-color: $tableRowBorderColor;
        font-size: 12px;
        padding: 5px;
        position: relative;
        padding-top: 8px;
        white-space: nowrap;
        text-overflow: ellipsis;
        max-width: 200px;
        &:hover > span.spl-swf-table__tooltip {
          display: block;
        }
      }

      td:hover {
        background-color: $tableColumnBackgroundColorHover;
        cursor: pointer;
      }

      td:first-child {
        border-left-width: 1px;
      }
    }

  }
</style>
